import React from 'react'

import AppMain from "../../../../core/gd-app/component/app-main/app-main"
import Confirmation from '../confirmation/confirmation'
import RequestForm_FormView from "../../../../app/tools/request-forms2/view-form/form-view"
import {SharedViewLogoTopPanel} from "../../../core/logo/logo-top-panel"

type Props = {
    app: any
}

type State = {
    view: 'form' | 'confirmation'
}

export default class Main extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            view: 'form'
        }
    }

    onNewRequest = () => {
        this.setState({
            view: 'form'
        })
    }

    onSubmit = () => {
        this.setState({
            view: 'confirmation'
        })
    }

    reRender() {
        this.forceUpdate()
    }

    render() {

        switch (this.state.view) {
            case 'confirmation':
                return (
                    <AppMain type="full">
                        <Confirmation requestForm   = {this.props.app.requestForm}
                                      onNewRequest  = {this.onNewRequest}/>
                    </AppMain>
                )

            default:
                return (
                    <AppMain type="full">
                        <SharedViewLogoTopPanel className   = "form-logo"
                                                logo        = {this.props.app.requestForm.settings.logo}/>

                        <div className="ui5-request-form">
                            <RequestForm_FormView publicKey     = {this.props.app.publicKey}
                                                  requestForm   = {this.props.app.requestForm}
                                                  onSubmit      = {this.onSubmit}/>
                        </div>
                    </AppMain>
                )
        }
    }
}
